if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initLoadMore);
}

document.addEventListener('DOMContentLoaded', initLoadMore);

function initLoadMore() {
  const loadMoreBtn = document.querySelector('.load-more-button');
  
  if (!loadMoreBtn) {
    console.log('Кнопка load-more не найдена');
    return;
  }
  
  console.log('Кнопка найдена!');
  
  if (loadMoreBtn.hasAttribute('data-initialized')) {
    return;
  }
  
  loadMoreBtn.setAttribute('data-initialized', 'true');
  
  loadMoreBtn.addEventListener('click', function(e) {
    e.preventDefault();
    
    const nextUrl = this.getAttribute('data-next-url');
    
    console.log('Клик! URL следующей страницы:', nextUrl);
    
    if (!nextUrl) {
      console.log('Нет URL следующей страницы');
      return;
    }
    
    this.textContent = 'Ładowanie...';
    this.disabled = true;
    
    fetch(nextUrl)
      .then(response => {
        console.log('Ответ получен');
        return response.text();
      })
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        
        // Ищем контейнер на текущей странице
        const productGrid = document.querySelector('#product-grid ul') || 
                           document.querySelector('.product-grid ul') ||
                           document.querySelector('#ProductGridContainer ul') ||
                           document.querySelector('ul.grid');
        
        // Ищем товары на новой странице - пробуем разные селекторы
        let newProducts = doc.querySelectorAll('#product-grid ul > li.grid__item');
        
        if (newProducts.length === 0) {
          newProducts = doc.querySelectorAll('.product-grid ul > li.grid__item');
        }
        
        if (newProducts.length === 0) {
          newProducts = doc.querySelectorAll('ul.grid > li.grid__item');
        }
        
        if (newProducts.length === 0) {
          newProducts = doc.querySelectorAll('#product-grid li');
        }
        
        console.log('Контейнер найден:', !!productGrid);
        console.log('Новых товаров найдено:', newProducts.length);
        
        if (productGrid && newProducts.length > 0) {
          newProducts.forEach(product => {
            productGrid.appendChild(product.cloneNode(true));
          });
        }
        
        const newLoadMoreBtn = doc.querySelector('.load-more-button');
        
        if (newLoadMoreBtn) {
          const newNextUrl = newLoadMoreBtn.getAttribute('data-next-url');
          console.log('Клик! URL следующей страницы:', newNextUrl);
          loadMoreBtn.setAttribute('data-next-url', newNextUrl);
          loadMoreBtn.textContent = 'Pokaż więcej';
          loadMoreBtn.disabled = false;
        } else {
          console.log('Больше страниц нет');
          loadMoreBtn.remove();
        }
      })
      .catch(error => {
        console.error('Ошибка загрузки:', error);
        loadMoreBtn.textContent = 'Błąd. Spróbuj ponownie';
        loadMoreBtn.disabled = false;
      });
  });
}
